export default __webpack_public_path__ + "static/media/30_TopRightSquares_Top.43a964c8.mp4";